export const navigationTitles = {
    standard: {
        home: "Inicio",
        dashboard: "Dashboard",
        citizenHome: "Mi espacio",
        officialDashboard: "Funcionario",
        emissions: "Emisión",
        interoperability: "Interoperabilidad",
        reports: "Reportes",
        audits: "Auditoría y trazabilidad",
        validation: "Validación de certificados",
        roles: "Gestión de roles",
        users: "Gestión de usuarios",
        dependencies: "Dependencias",
        aiAssistant: "Asistente IA",
        systemConfiguration: "Configuración del sistema",
        certificateConfiguration: "Configuración de certificados",
        datamart: "Datamart",
        monitoring: "NOC / Monitoreo",
        cadastral: "Consulta Catastral",
    },
    superAdmin: {
        commandCenter: "Centro de mando",
        certificates: "Certificados",
        dependencies: "Dependencias",
        configuration: "Configuración",
        routes: {
            "/home": "Inicio",
            "/dashboard": "Dashboard",
            "/interoperability": "Interoperabilidad",
            "/monitoring": "NOC/monitoreo",
            "/audits": "Auditoría y trazabilidad",
            "/emissions": "Emisión",
            "/certificate-configuration": "Configuración de certificado",
            "/certificates-validation": "Validación de certificados",
            "/reports": "Reportes",
            "/dependencies": "Dependencias",
            "/cadastral": "Consulta catastral",
            "/users-management": "Usuarios",
            "/roles": "Roles",
            "/system-configurations": "Sistema",
            "/datamart": "Datamart",
            "/ia-assistant": "Asistente IA",
        },
    },
};

const standardTitlesByPath = {
    "/home": navigationTitles.standard.home,
    "/dashboard": navigationTitles.standard.dashboard,
    "/dashboardciudadano": navigationTitles.standard.citizenHome,
    "/dashboardfuncionario": navigationTitles.standard.officialDashboard,
    "/emissions": navigationTitles.standard.emissions,
    "/interoperability": navigationTitles.standard.interoperability,
    "/reports": navigationTitles.standard.reports,
    "/audits": navigationTitles.standard.audits,
    "/certificates-validation": navigationTitles.standard.validation,
    "/roles": navigationTitles.standard.roles,
    "/users-management": navigationTitles.standard.users,
    "/dependencies": navigationTitles.standard.dependencies,
    "/ia-assistant": navigationTitles.standard.aiAssistant,
    "/system-configurations": navigationTitles.standard.systemConfiguration,
    "/certificate-configuration": navigationTitles.standard.certificateConfiguration,
    "/datamart": navigationTitles.standard.datamart,
    "/monitoring": navigationTitles.standard.monitoring,
    "/cadastral": navigationTitles.standard.cadastral,
};

const pageTitlesByPath = {
    "/myProfile": "Mi Perfil",
    "/miperfil": "Mi Perfil",
    "/certificate-types": "Tipos de certificados",
};

export function resolveNavigationTitle({ pathname, role }) {
    if (role === "SUPERADMIN") {
        return navigationTitles.superAdmin.routes[pathname] || pageTitlesByPath[pathname] || "";
    }

    return standardTitlesByPath[pathname] || pageTitlesByPath[pathname] || "";
}